/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_VerifyInputs */

const en_admin_indexnow_step_verify = /** @type {(inputs: Admin_Indexnow_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Key file`)
};

/**
* | output |
* | --- |
* | "2. Key file" |
*
* @param {Admin_Indexnow_Step_VerifyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_verify = /** @type {((inputs?: Admin_Indexnow_Step_VerifyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_VerifyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_verify(inputs)
});
export { admin_indexnow_step_verify as "admin.indexnow.step_verify" }